import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import Button from "react-bootstrap/esm/Button";
import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Col, ButtonGroup } from "react-bootstrap";
import AvailableDevices from "./AvailableDevices";
import UserDevices from "./UserDevices";
import { AddUserDeviceMutation, hash } from "../gql/AddUserDeviceMutation";
import {
  DeleteUserDeviceMutation,
  hash as hash2,
} from "../gql/DeleteUserDeviceMutation";
import { FaCamera } from "react-icons/fa";

const AssignDevices = ({ user }) => {
  const [show, setShow] = useState(false);
  const [current, setCurrent] = useState([]);
  const [selected, setSelected] = useState("");
  const [deselected, setDeselected] = useState("");
  const [errorMessage, setErrorMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);

  const userId = user.appId;

  const [assignDevice] = useMutation(AddUserDeviceMutation, {
    context: { headers: { "X-Trust-Key": hash } },
  });
  const [unassignDevice] = useMutation(DeleteUserDeviceMutation, {
    context: { headers: { "X-Trust-Key": hash2 } },
  });

  const addDevice = async () => {
    if (!selected || selected === "") {
      setErrorMessage("Please Select a Project.");
      return;
    }
    try {
      await assignDevice({
        variables: { userId: userId, id: selected },
      });
      setSelected("");
    } catch (error) {
      setErrorMessage("There was an error assigning this device.");
    }
  };

  const deleteDevice = async () => {
    if (!deselected || deselected === "") {
      setErrorMessage("Please Select a Project.");
      return;
    }
    try {
      await unassignDevice({
        variables: { id: deselected },
      });
      setDeselected("");
    } catch (error) {
      setErrorMessage("There was an error unassigning this device.");
    }
  };

  return (
    <>
      <Modal
        centered
        show={show}
        backdrop
        size="lg"
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Assign Devices for {user.firstName} {user.lastName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-auto d-flex flex-row align-items-center justify-content-center">
          <Col className="p-2 m-2">
            <AvailableDevices
              selected={selected}
              setSelected={setSelected}
              current={current}
            />
          </Col>
          <Col>
            <ButtonGroup>
              <Button
                size="sm"
                title="Unassign Device to user"
                style={{ color: "white" }}
                onClick={() => deleteDevice()}
              >
                <FaArrowLeft></FaArrowLeft>
              </Button>
              <Button
                size="sm"
                title="Assign Device to user"
                style={{ color: "white" }}
                onClick={() => addDevice()}
              >
                <FaArrowRight />
              </Button>
            </ButtonGroup>
          </Col>
          <Col className="p-2 m-2">
            <UserDevices
              userId={userId}
              setCurrent={setCurrent}
              deselected={deselected}
              setDeselected={setDeselected}
            />
          </Col>

          {successMessage && (
            <Alert>
              <p style={{ textAlign: "center" }}>
                Projects successfully assigned.
              </p>
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex flex-start-end flex-row align-items-center justify-content-between">
          {errorMessage && (
            <Alert
              variant="danger"
              dismissable
              closeVariant="white"
              onClick={() => setErrorMessage("")}
              onClose={() => setErrorMessage("")}
            >
              There was a problem assigning devices to this user.
            </Alert>
          )}
          <Button
            variant="danger"
            className="ms-auto"
            style={{ color: "white" }}
            onClick={() => {
              setErrorMessage("");
              setSuccessMessage(false);
              setShow(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Button
        title="Assign Devices"
        size="sm"
        disabled={!user.isExternal}
        variant="dark"
        style={{ color: "white" }}
        onClick={() => setShow(true)}
      >
        <FaCamera />
      </Button>
    </>
  );
};

export default AssignDevices;
